module.exports = __webpack_public_path__ + "media/images/promotions/point-ce7daeef0e383262d436e72a13c1db5e.svg";